import React, { useState } from 'react';
import classNames from 'classnames';
import Loader from 'src/components/Loader';
import styles from './assets/incentive-create-screen.module.scss';
import RoleLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/IncentiveForm';
import Breadcrumbs from 'src/components/Breadcrumbs';
import { routes } from 'src/navigation';
import { IProvider } from '../../../../../../types/provider';
import { Paginated } from '../../../../../../services/api-handlers/pagination';
import { toast } from 'react-toastify';
import { changeToZeroMoment } from '../../../../../../helpers/timeHelpers';
import moment from 'moment';

export interface StateProps {
    inProgress: boolean;
    valuesForm: any;
    providersIncentive: Paginated<Partial<IProvider>>;
}

export interface DispatchProps {
    getProvidersIncentive: (params: { dateFrom: string; dateTo: string }) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const IncentiveCreateScreen: React.FunctionComponent<Props> = (props) => {
    const { inProgress, valuesForm, getProvidersIncentive, providersIncentive } = props;
    const [stateData, setStateData] = useState<any>({});
    const [findNow, setFind] = useState<boolean>(false);

    const findProviders = () => {
        const data: any = {};
        setFind(true);
        data['dateFrom'] = valuesForm.dateFrom;
        data['dateTo'] = valuesForm.dateTo;
        const hoursStart = +moment(data['dateFrom']).format('H');
        const minStart = +moment(data['dateFrom']).format('m');
        data['dateFrom'] = moment(data['dateFrom'])
            .set('hour', hoursStart)
            .set('minute', minStart)
            .format('YYYY-MM-DD HH:mm:ss');

        const hoursEnd = +moment(data['dateTo']).format('H');
        const minEnd = +moment(data['dateTo']).format('m');
        data['dateTo'] = moment(data['dateTo'])
            .set('hour', hoursEnd)
            .set('minute', minEnd)
            .set('second', 0)
            .format('YYYY-MM-DD HH:mm:ss');
        if (valuesForm.dateFrom && valuesForm.dateTo) {
            getProvidersIncentive(data);
        }
    };
    const handleSub = (handleSubmit: (e: any) => void, e: any) => {
        if (Object.keys(stateData).length) {
            handleSubmit(e);
        } else {
            toast.error('No Sessions');
            return false;
        }
    };

    let list = providersIncentive?.list;

    list = list?.filter(function (el) {
        return (
            !(el.id == 60 && el.fullName == 'DELETED_1639148244_Outfitteщr') &&
            !(el.id == 169 && el.fullName == 'Angelina Mertsalovaa') &&
            !(el.id == 173 && el.fullName == 'Ksenia') &&
            !(el.id == 143 && el.fullName == 'Oksana')
        );
    });

    providersIncentive.list = list;

    providersIncentive.list.sort((a: Partial<IProvider>, b: Partial<IProvider>) => {
        const textA = a?.fullName ? a.fullName.toUpperCase() : '';
        const textB = b.fullName ? b.fullName.toUpperCase() : '';
        return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    return (
        <RoleLayout>
            {inProgress ? <Loader /> : null}
            <Breadcrumbs
                items={[
                    { name: 'RECEIVED BONUSES', path: routes.INCENTIVES_LIST },
                    { name: `GENERATE NEW`, path: '' },
                ]}
            />

            <div className={classNames(styles.wrapForm)}>
                <Form
                    handleSub={handleSub}
                    stateData={stateData}
                    setStateData={setStateData}
                    isFindProviders={findNow}
                    providersIncentive={providersIncentive}
                    findProviders={findProviders}
                    initialValues={{}}
                />
            </div>
        </RoleLayout>
    );
};

export default IncentiveCreateScreen;
